import React, { Component } from "react";
import PropTypes from "prop-types";
import Icon from "../elements/icon";

class VerticalTab extends Component {
  static propTypes = {
    icon: PropTypes.string,
    label: PropTypes.string,
    isActive: PropTypes.bool,
    handleClick: PropTypes.func,
  };

  static defaultProps = {
    icon: "",
    title: "",
    isActive: false,
    handleClick: () => null,
  };

  render() {
    const { isActive, label, icon, iconSize } = this.props;
    return (
      <div
        className={`et-vertical-tab-panel--nav-item ${isActive ? "active" : ""}`}
        role="button"
        tabIndex={0}
        onClick={() => this.props.handleClick(label)}
      >
        <Icon icon={icon} size={iconSize} />
        <div className="et-vertical-tab-panel--nav-item-label">{label}</div>
      </div>
    );
  }
}

export default VerticalTab;
